import { render, staticRenderFns } from "./moreShow.vue?vue&type=template&id=584b33b7&scoped=true&"
import script from "./moreShow.vue?vue&type=script&lang=js&"
export * from "./moreShow.vue?vue&type=script&lang=js&"
import style0 from "./moreShow.vue?vue&type=style&index=0&id=584b33b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b33b7",
  null
  
)

export default component.exports